// Login password rules — mirrors ChangePasswordDto on the backend.
export const LOGIN_PASSWORD_MIN_LENGTH = 8;
export const LOGIN_PASSWORD_MAX_LENGTH = 17;

export const LOGIN_PASSWORD_RULES_TEXT = `${LOGIN_PASSWORD_MIN_LENGTH}–${LOGIN_PASSWORD_MAX_LENGTH} characters, with at least one uppercase letter, one digit, and one special character.`;

export function isValidLoginPassword(password: string): boolean {
  return (
    password.length >= LOGIN_PASSWORD_MIN_LENGTH &&
    password.length <= LOGIN_PASSWORD_MAX_LENGTH &&
    /[A-Z]/.test(password) &&
    /\d/.test(password) &&
    /[^A-Za-z0-9]/.test(password)
  );
}
